<template>
  <!-- 站点信息 -->
  <div>
      <w-table
        v-if="typeName"
        v-loading.body="tableLoading"
        :data-list="historyData"
        :columns="staticData[typeName].columns"
        :pageNo="formData.pageNum"
        :pageSize="formData.pageSize"
        :total="total"
        :filters= "filterObj"
        :sortable="true"
        :pageSizes="[100, 200, 500]"
        @pageNoChange="pageNoChange"
        @pageSizeChange="pageSizeChange"
        >
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
          <span v-else-if="props.column.label === '时间'">
            <span>{{props.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
          </span>
          <span v-else-if="props.column.label === '站点名称'">
            <span class="cursor text-decoration" @click="jjSearch(props.row)">{{props.row.siteName}}</span>
          </span>
          <span v-else-if="props.column.label === '站点车辆'">
            <span class="blue">{{props.row.num}}</span>
          </span>
          <span v-else-if="props.column.label === '站点状态'">
            <span
              class="st"
              :class="{
                'blue': getSiteStatusNew(props.row.messageType)&&getSiteStatusNew(props.row.messageType).style === 0,
                'warning': getSiteStatusNew(props.row.messageType)&&getSiteStatusNew(props.row.messageType).style === 1,
                'red': getSiteStatusNew(props.row.messageType)&&getSiteStatusNew(props.row.messageType).style === 2,
                'origin': getSiteStatusNew(props.row.messageType)&&getSiteStatusNew(props.row.messageType).style === 3,
              }">
              {{getSiteStatusNew(props.row.messageType)&&getSiteStatusNew(props.row.messageType).status}}
            </span>
          </span>
          <span v-else>{{ props.row[props.column.property]}}</span>
        </template>
      </w-table>
    </div>
</template>

<script>
import WTable from '@/components/Table/index.vue'
import staticData from './staticData.js'
import Api from '@/api'
import { mapGetters } from 'vuex'

export default {
  components: {
    WTable
  },
  props: ['typeName'],
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 100
      },
      total: 0,
      tableLoading: false,
      historyData: [],
      filterObj: {
        status: [
          { text: '满桩', value: 1 },
          { text: '偏多', value: 2 },
          { text: '偏少', value: 3 },
          { text: '空桩', value: 4 }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['selfAreaId']),
    staticData() {
      return staticData
    }
  },
  created() {
    this.initData()
  },
  methods: {
    jjSearch(item) {
      console.log('jjSearch', item)
      this.$emit('jjSearch', item)
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      const params = {
        selfAreaId: vm.selfAreaId,
        currentPage: vm.formData.pageNum,
        pageSize: vm.formData.pageSize
      }
      Api.getDashboardTodayHistory(params)
        .then(res => {
          if (res.code === 200) {
            vm.historyData = res.data.lists
            vm.total = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
    },
    onShowDialog2(item) {
      const data = {
        ...item,
        type: 'siteBikes'
      }
      this.$emit('onShowDialog2', data)
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    },
    getSiteStatusNew(messageType) {
      return {
        empty: {
          style: 0,
          status: '空桩'
        },
        less: {
          style: 1,
          status: '偏少'
        },
        more: {
          style: 3,
          status: '偏多'
        },
        full: {
          style: 2,
          status: '满桩'
        }
      }[messageType]
    },
    getSiteStatus(curr, total) {
      const obj = {
        style: '',
        status: ''
      }
      if (curr === 0) {
        obj.style = 0 // 空桩  蓝色icon
        obj.status = '空桩'
      } else if (curr / total < 0.2) {
        obj.style = 1 // 偏少  绿色icon
        obj.status = '偏少'
      } else if (curr / total > 0.8 && curr / total < 1) {
        obj.style = 3 // 偏多  黄色icon
        obj.status = '偏多'
      } else if (curr / total >= 1) {
        obj.style = 2 // 满桩  红色icon
        obj.status = '满桩'
      } else {
        obj.style = 4 // 正常
        obj.status = '正常'
      }
      return obj
    }
  }
}
</script>

<style lang="less">

</style>
